<template>
  <div class="switcher">
    <div class="switcher__fieldset">
      <input
        :id="`${name}-1`"
        v-model="internalValue"
        type="radio"
        :name="name"
        :value="leftValue"
      />
      <label :for="`${name}-1`">{{ leftText }}</label>
      <input
        :id="`${name}-2`"
        v-model="internalValue"
        type="radio"
        :name="name"
        :value="rightValue"
      />
      <label :for="`${name}-2`">{{ rightText }}</label>
      <span class="switcher__switch"></span>

      <Badge v-if="saveText" class="switcher__right-text" color="info">
        {{ saveText }}
      </Badge>
    </div>
  </div>
</template>

<script>
import { Badge, useProxiedModel } from '@campsite-bio/component-lib';

export default {
  components: {
    Badge,
  },

  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    leftValue: {
      type: String,
      required: true,
    },
    leftText: {
      type: String,
      required: true,
    },
    rightValue: {
      type: String,
      required: true,
    },
    rightText: {
      type: String,
      required: true,
    },
    saveText: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const internalValue = useProxiedModel(props, 'value');

    return {
      internalValue,
    };
  },
};
</script>

<style lang="scss" scoped>
.switcher__fieldset {
  border: 1px solid $color-mine-shaft;
  border-radius: var(--g-border-radius-standard);
  border-radius: Min(
    var(--g-border-radius-standard),
    var(--g-border-radius-min)
  );
  display: inline-flex;
  padding: 0.125rem;
  position: relative;
  text-align: center;
}

.switcher input {
  position: absolute;
  opacity: 0;
}

.switcher label {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  width: 5.625rem;
  height: 2.5rem;
  line-height: 2.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  color: $color-mine-shaft;
}

.switcher__switch {
  position: absolute;
  top: 0.125rem;
  left: 0.125rem;
  height: 2.5rem;
  width: 5.625rem;
  background-color: #ccc;
  border-radius: var(--g-border-radius-standard);
  border-radius: Min(
    var(--g-border-radius-standard),
    var(--g-border-radius-min)
  );
  transition: transform 0.5s;
}

.switcher input:checked + label + .switcher__switch,
.switcher input:checked + label:nth-of-type(n) + .switcher__switch {
  transform: translateX(5.625rem);
}

.switcher__right-text {
  margin-left: 0.5rem;
  white-space: nowrap;
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
}
</style>
